import React from 'react';
import './eventsPage.module.scss';
import { Page } from '../../components/atoms/layout/Page';
import { PageHeader } from '../../components/atoms/layout/PageHeader';
import { PageBody } from '../../components/atoms/layout/PageBody';
import { EventsPageContext } from './states/EventsPageState';
import { AllEventSection } from '../../components/organisms/events/AllEventSection';
import { EventArchivesSection } from '../../components/organisms/events/EventArchivesSection';
import { useStateContext } from '../../hooks/useStateContext';
import Slider from 'react-slick';
import { useNavigation } from '../../components/hocs/withNavigation';
import { FooterSpecs, useFooter } from '../../states/FooterState';
import { NavigationSpecs } from '../../states/NavigationState';
import { useViewportState } from '../../../commonv3/hooks/useViewportState';
import classnames from 'classnames';
import { CATEGORY_TAGS } from '../../components/organisms/events/states/EventListState';
import { OverlayPage } from '../../../commonv3/components/molecules/layout/OverlayPage';
import { EventPane } from '../../components/organisms/events/EventPane';
import { routingStore } from '../../../common/stores/routing';
import { V3Routes } from '../../routes';
import { RouteComponentProps } from 'react-router';
import { parseQueryParams } from '../../types/location';
import { FlagKeys } from '../../../mainv2/states/CurrentUserState';
import CalendarBanner from './images/schedule_calendar_banner.svg';
import { restrictAccessForUser } from '../../../commonv3/hooks/restrictAccessForUser';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';

const PICKUP_EVENT_AMOUNT = 6;
const SLIDER_SETTINGS = {
  adaptiveHeight: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000,
  variableWidth: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
} as const;

type Props = RouteComponentProps;

export const EventsPage = (props: Props) => {
  const [locations, eventList, archivedEventList, currentUser] = useStateContext(EventsPageContext, [
    'locations',
    'eventList',
    'archivedEventList',
    'currentUser',
  ] as const);
  restrictAccessForUser();
  useNavigation(NavigationSpecs.side());
  useFooter(FooterSpecs.likes());
  eventList.setSelectedCategoryTagSelectors([...CATEGORY_TAGS]);
  eventList.setSelectedAttributeTagSelectors([]);
  archivedEventList.setSelectedCategoryTagSelectors([...CATEGORY_TAGS]);
  archivedEventList.setSelectedAttributeTagSelectors([]);

  const { event_id } = parseQueryParams(props.location);
  const eventId = Array.isArray(event_id) ? event_id[0] : event_id;
  const isShowCarousel = currentUser.hasEnabledFlagKey(FlagKeys.SHOW_CAROUSEL_IN_EVENT_PAGE);
  const breadCrumbItems = [{ text: 'イベント' }];

  return (
    <Page>
      <BreadCrumb items={breadCrumbItems} hasHome />
      {isShowCarousel && (
        <>
          <PageHeader title="PICKUP EVENT" testId="page-header-of-events" />
          <PickupEventsCarousel />
        </>
      )}
      <PageBody styleName={classnames('body', isShowCarousel ? '' : 'exclude-carousel')}>
        <AllEventSection locations={locations} eventList={eventList} currentUser={currentUser} />
        <EventArchivesSection locations={locations} eventList={archivedEventList} currentUser={currentUser} />
        <OverlayPage open={!!eventId} onRequestClose={() => routingStore.push(V3Routes.events())} id={'events'}>
          {eventId && <EventPane eventId={eventId} />}
        </OverlayPage>
      </PageBody>
      {!isShowCarousel && (
        <div styleName="schedule-calendar-banner">
          <a
            href="https://shelikes.jp/home?redirect_url=https://calendar.google.com/calendar/u/0/embed?src=c_hs5tqo3jd0100be9lrrn8cum8s@group.calendar.google.com&ctz=Asia/Tokyo"
            target="_blank"
          >
            <img src={CalendarBanner} />
          </a>
        </div>
      )}
    </Page>
  );
};

const PickupEventsCarousel = () => {
  const { isSp } = useViewportState();
  const settings = { ...SLIDER_SETTINGS, dots: !isSp };
  return (
    <section styleName={classnames('pickup-event-carousel', { '-sp': isSp })}>
      <Slider {...settings}>
        {[...Array(PICKUP_EVENT_AMOUNT)].map((_, index) => (
          <div key={`pickup-event-${index}`}>
            <div className={`js-pickup-event-${index}`} styleName="card">
              <div styleName="placeholder">
                <img className={`js-pickup-event-image-${index}`} />
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};
